const boldRegex = /bold\("(.*?)"\)/gi;

export default class Utils {
	static converToBold = (value: any) => {
        const convert:string = value.replace(boldRegex, "<em>$1</em>");
        // console.log(convert);
        return convert;
    }

    static height = () => {
        let body = document.body,
            html = document.documentElement;
    
        return Math.max( body.scrollHeight, body.offsetHeight,  html.clientHeight, html.scrollHeight, html.offsetHeight );
    }
}